<template>
  <div class="categoryProducts">
    <div class="categoryProducts-title">
      <el-select
        v-model="logistic_business_id"
        filterable
        style="width: 20%"
        @change="logisticchange"
        placeholder="请选择集配中心"
      >
        <el-option
          v-for="item in options"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </div>
    <div class="categoryProducts-cnt">
      <div class="categoryProducts-cnt-left">
        <div class="mb-10 d-flex a-center">
          <el-select
            v-model="key"
            filterable
            remote
            placeholder="请输入"
            :remote-method="remoteMethod"
            @visible-change="onChangeVisible"
            :loading="loadingSearch"
            @change="change"
            clearable
          >
            <div>
              <el-option
                v-for="item in cateSearchList"
                :key="item.id"
                :label="`${item.p_name}-${item.name}`"
                :value="item.id"
              >
              </el-option>
            </div>
          </el-select>
        </div>
        <el-tree
          ref="tree"
          :data="treeData"
          :props="defaultProps"
          node-key="id"
          :highlight-current="false"
          @node-click="handleNodeClick"
        >
          <span
            slot-scope="{ node, data }"
            :class="
              (node.level == 1 && currentHighlightLevel1 == data.id) ||
              (node.level == 2 && currentSelectedLevel2 == data.id)
                ? 'cateBg'
                : ''
            "
          >
            {{ node.label }}
          </span>
        </el-tree>
      </div>
      <div class="categoryProducts-cnt-right">
        <!-- 表单搜索 start -->
        <Filtersearch
          ref="Filtersearchref"
          :list="Filtersearchlist"
          :fromdata="formData"
          @Refresh="onHandleRefresh"
          @search="onSearch"
        >
          <template v-slot:left v-if="currentSelectedLevel2">
            <el-button type="primary" @click="KeyAttributes"
              >关键属性</el-button
            >
            <el-button type="primary" @click="openConfigProperties"
              >配置属性</el-button
            >
            <el-button type="primary" @click="openBatchSit"
              >批量设置坑位</el-button
            >
          </template>
        </Filtersearch>
        <!-- 表单搜索 end -->
        <div class="auto-table-flex">
          <el-table
            :data="tableData"
            height="100%"
            ref="table"
            v-loading="loading"
            :border="true"
            :header-cell-style="{ color: '#333333', background: '#EFF6FF' }"
          >
            <el-table-column
              type="index"
              width="100px"
              align="center"
              label="序号"
            >
            </el-table-column>
            <el-table-column prop="name" align="center" label="品类名称">
            </el-table-column>
            <el-table-column prop="slot" align="center" label="坑位">
            </el-table-column>
            <el-table-column prop="name" align="center" label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click="ProductCategory(scope.row)"
                  >商品审核</el-button
                >
                <el-button type="text" @click="openSetThreePit(scope.row)"
                  >设置坑位</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- <div class="fy">
          <el-pagination
            type="primary"
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="formData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div> -->
      </div>
    </div>
    <!--  批量设置坑位 start -->
    <batchSetPit ref="batchSetPitRef" @submit="getdownconfiglist" />
    <!--  批量设置坑位 end -->

    <!--  配置属性 start -->
    <configProperties ref="configPropertiesRef" />
    <!--  配置属性 end -->

    <!-- 单个设置三级品类坑位 start -->
    <setThreePit ref="setThreePitRef" @submit="getdownconfiglist" />
    <!-- 单个设置三级品类坑位 end -->
  </div>
</template>

<script>
import cloneDeep from "lodash/cloneDeep";
import Filtersearch from "@/components/Filtersearch.vue";
import batchSetPit from "./modules/batch-set-pit.vue";
import configProperties from "./modules/config-properties.vue";
import setThreePit from "./modules/set-three-pit.vue";
import {
  getCategoriesList,
  postCategoriesSearch,
  postCategoriesTagList,
} from "@/api/generalControl/category";

export default {
  name: "categoryProducts",
  components: { Filtersearch, batchSetPit, configProperties, setThreePit },
  data() {
    return {
      treeData: [],
      defaultProps: {
        children: "child",
        label: "name",
      },
      options: [],
      logistic_business_id: "",
      total: 0,
      currentPage: 0,
      loading: false,
      tableData: [],
      formData: {
        logistic_business_id: "", //	T文本	是	集配中心id
        page: 1,
        pageSize: 9999, // 写死 因为要批量设置坑位
        cid: "", // 二级分类id
      }, // 表单参数
      formDataClone: {}, // 表单参数拷贝，用于重置
      Filtersearchlist: [],

      currentSelectedLevel2: null, // 当前选中的二级节点id
      currentHighlightLevel1: null, // 当前需要高亮的一级节点id
      cidType: "", // 二级分类关键属性跳转参数
      key: "",
      cateSearchList: [],
      loadingSearch: false,
      scrollTop:0
    };
  },
  mounted() {
    
     this.$store.commit("addcachedViews", 'categoryProducts');//想要缓存页面传输到vuex
    this.formDataClone = cloneDeep(this.formData);
    this.getcollective();
     // 监听滚动条的位置
    this.$refs.table.bodyWrapper.addEventListener(
      "scroll",
      res => {
   let height = res.target;
        this.scrollTop = height.scrollTop;
 
      },
      false
    );
  },
    activated() {
 

     this.$nextTick(() => {
    if (this.$refs.table) {
       setTimeout(() => {
          // 设置滚动条的位置
         this.$refs.table.doLayout();
      this.$refs.table.bodyWrapper.scrollTop = this.scrollTop;
        }, 100); // 需要设置延迟，否则无效
      
    }
  });
  },

          
  methods: {
  
    // 点击一级二级树分类
    handleNodeClick(data, node) {
      console.log(data, node);
      // 如果点击的是一级节点，我们不做选中操作，但是可以展开/折叠
      if (node.level === 1) {
        // 一级节点，我们可能想要展开/折叠，这里默认行为是切换展开，所以我们不需要额外处理
        // 但是我们不想选中一级节点，所以这里返回
        return;
      } else if (node.level === 2) {
        // 二级节点
        this.currentSelectedLevel2 = data.id;
        this.cidType = data.type;
        // 找到父节点（一级节点）
        this.currentHighlightLevel1 = data.pid;
        this.formData.cid = data.id;
        this.getdownconfiglist(); // 请求对应的三级分类列表
      }
    },
    // 批量设置坑位
    openBatchSit() {
      this.$refs.batchSetPitRef.onInitData(
        this.tableData,
        this.formData.logistic_business_id
      );
    },
    // 配置属性
    openConfigProperties() {
      this.$refs.configPropertiesRef.onInitData(this.formData);
    },
    // 单个设置坑位
    openSetThreePit(e) {
      this.$refs.setThreePitRef.onInitData(
        e,
        this.formData.logistic_business_id
      );
    },
    // 三级品类跳转商品审核
    ProductCategory(e) {
      console.log(e);
      let arr = { name: e.name, url: "/categoryProductslist" };
      sessionStorage.setItem("breadcrumbListpath", JSON.stringify(arr));
      this.$router.push({
        path: `/categoryProductslist`,
        query: {
          logistic_business_id: this.logistic_business_id,
          cid: e.cid,
          tagId: e.id,
        },
      });
    },
    // 左侧一级二级品类
    async getAjaxCategoriesList() {
      let { data } = await getCategoriesList({
        is_tree: 1,
        logistic_business_id: this.formData.logistic_business_id,
      });
      console.log(data, "da");
      this.treeData = data;

      if (data.length > 0) {
        this.currentHighlightLevel1 = data[0].id;
        this.cidType = data[0].child[0].type;
        this.currentSelectedLevel2 = data[0].child[0].id;
        this.$nextTick(() => {
          // 展开对应的一级分类下拉
          const node = this.$refs?.tree.getNode(data[0].id);
          if (node) {
            node.expand();
          }
        });
        this.formData.cid = data[0].child[0].id;
        this.getdownconfiglist(); // 请求对应的三级分类列表
      }
    },
    // 检索二级分类
    async postAjaxCategoriesSearch(e) {
      try {
        const res = await postCategoriesSearch({
          key: e || "",
          logistic_business_id: this.formData.logistic_business_id,
        });
        this.cateSearchList = res.data || [];
      } catch (error) {
        console.log(error, "postCategoriesSearch");
      } finally {
        this.loadingSearch = false;
      }
    },
    /**
     *下拉框远程搜索
     */
    remoteMethod(query) {
      if (query !== "") {
        this.loadingSearch = true;
        this.postAjaxCategoriesSearch(query);
      } else {
        this.cateSearchList = [];
      }
    },
    /**
     * 下拉框出现/隐藏时触发
     */
    onChangeVisible(e) {
      if (!e) {
        this.cateSearchList = [];
      }
    },
    /**
     * 下拉框改变
     */
    change(e) {
      console.log(e, "e===");
      if (e) {
        let tmpObj = {};
        this.cateSearchList.forEach((item) => {
          if (item.id == e) {
            tmpObj = item;
          }
        });
        console.log(tmpObj, "ewwe");
        this.currentHighlightLevel1 = tmpObj.p_id;
        this.cidType = tmpObj.type;
        this.currentSelectedLevel2 = e;
        // 展开对应的一级分类下拉
        const node = this.$refs.tree.getNode(tmpObj.p_id);
        if (node) {
          node.expand();
        }
        this.formData.cid = e;
        this.getdownconfiglist(); // 请求对应的三级分类列表
      }
    },
    // 关键属性
    KeyAttributes() {
      this.$router.push({
        path: `/key-attributes`,
        query: {
          first_cid: this.currentHighlightLevel1,
          cid: this.currentSelectedLevel2,
          cidType: this.cidType,
        },
      });
    },
    /**
     * 重置表单，并刷新
     */
    onHandleRefresh() {
      this.formData = {
        ...this.formDataClone,
      };
      this.formData.logistic_business_id = this.logistic_business_id;
      this.formData.cid = this.currentSelectedLevel2;
      this.getdownconfiglist();
    },
    /**
     * 搜索表单
     */
    onSearch(e) {
      this.formData = e;
      this.formData.page = 1;
      this.getdownconfiglist();
    },
    // handleSizeChange(val) {
    //   //   console.log(`每页 ${val} 条`);
    //   this.formData.pageSize = val;
    //   this.getdownconfiglist();
    // },
    // handleCurrentChange(val) {
    //   this.formData.page = val;
    //   this.currentPage = val;
    //   this.getdownconfiglist();
    // },
    // 三级分类列表
    async getdownconfiglist() {
      this.loading = true;
      try {
        const res = await postCategoriesTagList(this.formData);
        console.log(res);
        this.tableData = res.data.list;
        this.total = res.data.total;
        this.loading = false;

      } catch (error) {
        console.log(error, "postCategoriesTagList");
      } finally {
        this.loading = false;
      }
    },
    logisticchange() {
      this.$api.decoration.collective({ is_online: 1 }).then((res) => {
        this.options = res.data;
        this.formData.logistic_business_id = this.logistic_business_id;
        this.getAjaxCategoriesList();
      });
    },
    getcollective() {
      this.$api.decoration.collective({ is_online: 1 }).then((res) => {
        this.options = res.data;
        this.logistic_business_id = res.data[0].id;
        this.formData.logistic_business_id = this.logistic_business_id;
        this.getAjaxCategoriesList();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.categoryProducts {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 10px;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;

  .categoryProducts-title {
    background-color: #fff;
    padding: 20px;
    box-sizing: border-box;
  }

  .categoryProducts-cnt {
    flex-grow: 1;
    overflow-y: hidden;
    display: flex;
    margin-top: 10px;

    .categoryProducts-cnt-left {
      width: 15%;
      height: 100%;
      background-color: #fff;
      margin-right: 10px;
      padding: 20px;
      overflow-y: auto;
      box-sizing: border-box;
    }

    .categoryProducts-cnt-right {
      width: 85%;
      height: 100%;
      display: flex;
      flex-direction: column;
      flex-wrap: nowrap;

      .auto-table-flex {
        flex-grow: 1;
        overflow-y: hidden;
        margin-bottom: 10px;
      }
    }
  }

  // 一级节点点击提示
  /deep/ .el-tree-node:not(.is-leaf) > .el-tree-node__content {
    cursor: pointer;
  }
  .cateBg {
    background: #13ae67;
    color: white;
    flex: 1;
  }
  /deep/ .el-tree-node__content {
    display: flex !important;
  }
}
</style>
